import GeographicalCountryStack from "components/company/sections/summary/adornments/GeographicalCountryStack";
import PinIcon from "components/company/sections/summary/icons/PinIcon";
import PropertyIcon from "components/company/sections/summary/icons/PropertyIcon";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";
import notUndefinedOrNull from "lib/utils/notUndefinedOrNull";

interface IEquityInterestsSummaryProps {
  equityInterests: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["equityInterests"]>;
}

export default function EquityInterestsSummary({ equityInterests }: IEquityInterestsSummaryProps) {
  const countriesCount = new Set(
    equityInterests.map((equityInterest) => {
      return equityInterest.geographicalCountry ? equityInterest.geographicalCountry.name : equityInterest.country;
    }),
  ).size;

  const equityInterestsCount = equityInterests.length;

  return (
    <div className="flex items-center justify-between space-x-6 xl:justify-start">
      <div className="space-y-1 text-sm font-normal text-gray-600">
        <div className="flex items-center space-x-2">
          <PinIcon width={13} height={15} />
          <span>
            {countriesCount} {countriesCount === 1 ? "país" : "países"}
          </span>
        </div>

        <div className="flex items-center space-x-2">
          <PropertyIcon width={13} height={13} />
          <span>
            {equityInterestsCount} {equityInterestsCount === 1 ? "sociedade" : "sociedades"}
          </span>
        </div>
      </div>

      <GeographicalCountryStack
        geographicalCountries={equityInterests
          .map(({ geographicalCountry }) => geographicalCountry || null)
          .filter(notUndefinedOrNull)}
      />
    </div>
  );
}
